import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";
import { useToast } from "../../../context/ToastProvider";

const QuotationLossReasonList = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    const { triggerToast } = useToast();
    const { searchData } = useContext(DataContext);
    const [currentPage, setCurrentPage] = useState(1);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [quotationLostReasonListButton, setQuotationLostReasonListButton] = useState("");
    const [quotationLostReasonListData, setQuotationLostReasonListData] = useState([]);
    const [editQuotationLostReasonList, setEditQuotationLostReasonList] = useState("");
    const [errors, setErrors] = useState(null);
    const [
        paginationQuotationLostReasonListData,
        setPaginationQuotationLostReasonListData,
    ] = useState([]);
    const [editQuotationDiscussionStationId, setEditQuotationDiscussionStationId] =
        useState("");

    const [quotationLostReasonListInputs, setQuotationLostReasonListInputs] = useState({
        reason: "",
    });

    const fetchQuoteLostReasonList = async (page = 1) => {
        const token = localStorage.getItem("token");
        if (!token) {
            triggerToast("error", "Authorization token is missing", "error");
            // toast.error("Authorization token is missing");
            return;
        }

        try {
            const apiUrl = searchData
                ? `public/api/quotation-loss-reasons\?page=${page}&search=${searchData}`
                : `public/api/quotation-loss-reasons?page=${page}`;

            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

     

            setQuotationLostReasonListData(response?.data?.loss_reasons);
            setPaginationQuotationLostReasonListData(response?.data?.loss_reasons);
        } catch (error) {
            console.error("Error fetching lead sources:", error);
        }
    };
    useEffect(() => {
        fetchQuoteLostReasonList(currentPage);
    }, [searchData, currentPage]);



    const handleAddQuoteLostReasonList = () => {
        setQuotationLostReasonListButton("save");
        setQuotationLostReasonListInputs({ setQuotationLostReasonListInputs: "" });
        setIsDialogOpen(true);
    }

    const handleChangeForleadLostReasonList = (e) => {
        setQuotationLostReasonListInputs({
            [e.target.name]: e.target.value,
        });
    };

    const handleSaveQuoteLostReasonList = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(
                "public/api/quotation-loss-reasons",
                quotationLostReasonListInputs,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            setIsDialogOpen(false);
            
            triggerToast("success", "Lost Reason added successfully", "success");
            fetchQuoteLostReasonList();
        } catch (error) {
            triggerToast("error", "Failed to add Lost Reason", "error");
           
            setErrors( error.response.data.errors);
        }
    }


    const handleEditQuoteLostReasonList = async (id) => {
        setEditQuotationDiscussionStationId(id);
        setIsDialogOpen(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`public/api/quotation-loss-reasons/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

          

            const leadLostReasonListData = response.data;

            // Correctly setting the state
            setQuotationLostReasonListInputs({ reason: leadLostReasonListData.reason });

            setEditQuotationLostReasonList(id);
            setQuotationLostReasonListButton("update");
            setIsDialogOpen(true);

        } catch (error) {
            triggerToast("error", "Failed to fetch Quotation Lost Reason for editing", "error");
        }
    }


    const handleUpdateQuoteLostReasonList = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            setQuotationLostReasonListButton("update");
            const response = await axios.put(
                `public/api/quotation-loss-reasons/${editQuotationDiscussionStationId}`,
                quotationLostReasonListInputs,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
             if (response.data) {
                setIsDialogOpen(false);
                triggerToast("success", "Lost Reason updated successfully", "success");
                // toast.success("Lost Reason updated successfully");
                await fetchQuoteLostReasonList();
            } else {
                triggerToast("error", "Failed to update Lost Reason", "error");
                // toast.error("Failed to update Lost Reason");
            }
        } catch (error) {
            triggerToast("error", "Failed to update Lost Reason", "error");
        }
    }




    return (
        <div>
            <HeaderWithButton
                title="Quotation Lost Reason"
                description="Lost Reason for Quotation"
                buttonText="Lost Reason"
                onButtonClick={handleAddQuoteLostReasonList}
            // showButton={leadLostReasonListPermission}
            />

            <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
                <div className="mt-6 overflow-x-auto rounded-lg shadow">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                                    S No
                                </th>
                                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                    Lost Reason
                                </th>
                                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                                    Actions
                                </th>
                            </tr>
                        </thead>

                        <tbody className="bg-white divide-y divide-gray-200 ">
                            {quotationLostReasonListData?.data?.length > 0 ? (
                                quotationLostReasonListData?.data.map((item, index) => (
                                    <tr key={index}>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                            {index + 1}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                            {item.reason}
                                        </td>
                                        <td className="my-anchor-edit px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center">
                                            <>
                                                <button
                                                    className="my-anchor-edit bg-green-400 text-white text-sm py-1 px-2 rounded mr-2 transition duration-200"
                                                    onClick={() =>
                                                        handleEditQuoteLostReasonList(
                                                            item.id_crypt
                                                        )
                                                    }
                                                >
                                                    <PencilSquareIcon className="h-5 w-5 text-white" />
                                                    <Tooltip
                                                        anchorSelect=".my-anchor-edit"
                                                        place="top"
                                                        className="text-xs p-0"
                                                        style={{ fontSize: "12px", padding: "0.3rem" }}
                                                    >
                                                        Edit
                                                    </Tooltip>
                                                </button>

                                                {/* <DeleteConfirmation
                                                    id_crypt={item.id_crypt}
                                                    apiType="QuoteLostReason"
                                                    fetchClientData={fetchQuoteLostReasonList}
                                                /> */}
                                            </>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                        No Data Found
                                    </td>
                                </tr>

                            )}
                        </tbody>
                    </table>
                </div>
                {isDialogOpen && (
                    <Dialog
                        open={isDialogOpen}
                        onClose={() => setIsDialogOpen(false)}
                        className="relative z-10"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                                    <div
                                        className="flex justify-between items-center mb-4 p-4"
                                        style={{ backgroundColor: "#6366f1" }}
                                    >
                                        <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                                            Lost Reason
                                        </h1>
                                        <button
                                            type="button"
                                            onClick={() => setIsDialogOpen(false)}
                                        >
                                            <XMarkIcon
                                                className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                    <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                            <div className="sm:col-span-2">
                                                <form>
                                                    <div className="overflow-hidden sm:rounded-md">
                                                        <div className="space-y-4">
                                                            <div>
                                                                <label
                                                                    htmlFor="leadLostReasonList"
                                                                    className="block text-sm font-medium leading-6 text-gray-900"
                                                                >
                                                                    Reason
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        name="reason"
                                                                        type="text"
                                                                        value={quotationLostReasonListInputs.reason}
                                                                        onChange={handleChangeForleadLostReasonList}
                                                                        autoComplete="mode"
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                                    />
                                                                </div>
                                                                {errors && (
                                                                    <p className="mt-1 text-sm text-red-600">
                                                                        {errors.reason}
                                                                    </p>
                                                                )}
                                                            </div>

                                                            <div className="flex  space-x-2">
                                                                {quotationLostReasonListButton === "save" ? (
                                                                    <button
                                                                        onClick={handleSaveQuoteLostReasonList}
                                                                        className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                    >
                                                                        Add
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        onClick={handleUpdateQuoteLostReasonList}
                                                                        className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                    >
                                                                        Update
                                                                    </button>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setIsDialogOpen(false)}
                                                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>

        </div>
    )
}

export default QuotationLossReasonList